import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import RuteandoLanding from "./ruteando/ruteando";
import { ErrorBoundary } from "./error-boundary";
import { iniciarSeguimiento } from "./analytics/track";

// El CSS del mapa se importa estático a propósito: con splitting activo, si
// solo lo importara el chunk lazy, esbuild lo emitiría como CSS de chunk que
// el HTML nunca carga (esbuild no auto-inyecta CSS de dynamic imports). El
// costo es chico (va dentro de main.css); el JS y las imágenes sí van lazy.
import "./mapa/mapa.styles.css";
// Mismo motivo para el panel privado /analytics.
import "./analytics/analytics.styles.css";

// Routing manual minimo: sin router, tres destinos posibles. /mapa y
// /analytics se cargan lazy para no engordar el bundle inicial de la landing.
const MapaPage = lazy(() => import("./mapa/mapa"));
const AnalyticsPage = lazy(() => import("./analytics/analytics"));

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const isMapa = path === "/mapa";
const isAnalytics = path === "/analytics";

function Ruta() {
  if (isAnalytics) {
    return (
      <Suspense fallback={null}>
        <AnalyticsPage />
      </Suspense>
    );
  }
  if (isMapa) {
    return (
      <Suspense fallback={null}>
        <MapaPage />
      </Suspense>
    );
  }
  return <RuteandoLanding />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <Ruta />
    </ErrorBoundary>
  </StrictMode>,
);

// Analitica propia: una vista por carga, despues del render para no competir
// con el primer pintado. El propio /analytics no se cuenta.
iniciarSeguimiento();
